import { render, staticRenderFns } from "./edit-price-popup.vue?vue&type=template&id=5d4ad5ee&scoped=true&"
import script from "./edit-price-popup.vue?vue&type=script&lang=js&"
export * from "./edit-price-popup.vue?vue&type=script&lang=js&"
import style0 from "./edit-price-popup.vue?vue&type=style&index=0&id=5d4ad5ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ad5ee",
  null
  
)

export default component.exports